// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"style_menuIcon__CiMJA","disabledItem":"style_disabledItem__35CES"};